'use client';

import { AuthProvider } from '@/auth';
import { GlobalToast } from '@UI/GlobalToast';
import { SetupHooks } from './SetupHooks';
import { ConsentBanner } from './ConsentBanner/ConsentBanner';

const ClientWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    return (
        <AuthProvider>
            <GlobalToast/>
            <SetupHooks />
            <ConsentBanner />
            {children}
        </AuthProvider>
    );
};

export default ClientWrapper;
